module.exports = __webpack_public_path__ + "img/グループ 263.eedc505d.png";